/* ─────────────────────── DESIGN TOKENS (Landing Page) ─────────────────────── */
export const LIGHT_COLORS = {
    bg: "#F4F6F8",           // Fundo principal claro (cinza/azulado suave)
    bgDark: "#000818",       // Fundo escuro do template (Dark Mode paper)
    purple: "#418FDE",       // Primary Light (Substitui o roxo claro)
    purpleDark: "#001E62",   // Primary Main (Substitui o roxo escuro)
    primaryLight: "#418FDE", // Alias para o azul claro
    primaryMain: "#001E62",  // Alias para o azul principal
    secondaryNavy: "#08336C",// Azul marinho do template
    secondaryDeep: "#011030",// Azul ultra escuro do template
    success: "#00965E",      // Cor de sucesso oficial
    error: "#D22D4B",        // Cor de erro oficial
    white: "#FFFFFF",
    black: "#000818",        // Deep dark blue (Substitui o preto absoluto)
    textDark: "#000000",     // Texto escuro
    textMuted: "#7F7F7F",    // Secondary Light (Cinza médio)
    cardPurple: "#418FDE",   // Card Primary Light
    cardBlack: "#011030",    // Card Secondary Darkest
    cardGrey: "#EAEAEA",     // Card Cinza
    cardCoral: "#F55F73",    // Card Error (Vermelho)
    cardYellow: "#FFC845",   // Card Warning (Amarelo)
    cardDarkPurple: "#021748", // Card Primary Darkest
};

export const DARK_COLORS = {
    ...LIGHT_COLORS,
    bg: "#050811",           // Deep Obsidian Canvas
    bgDark: "#F4F6F8",
    // Um único azul de destaque no modo escuro: botões, ícones e cards usam o azul da marca
    primaryMain: "#418FDE",
    primaryLight: "#418FDE",
    purpleDark: "#418FDE",
    cardPurple: "#418FDE",
    white: "#FFFFFF",        // Pure Crisp White
    black: "#0b1120",        // Midnight Slate Paper
    textDark: "#FFFFFF",     // Pure White Headings
    textMuted: "#94a3b8",    // Slate 400
    cardGrey: "#0f172a",     // Midnight Slate Cards
};

export const FONTS = {
    heading: "'Outfit', 'Space Grotesk', system-ui, -apple-system, sans-serif",
    body: "'Outfit', system-ui, -apple-system, sans-serif",
};

// Larguras de corte da landing (as mesmas em todas as seções)
export const LANDING_MOBILE = "(max-width:767.95px)";       // celular: tudo em coluna, botões menores
export const LANDING_COMPACT_NAV = "(max-width:1023.95px)"; // celular e tablet: os links do topo viram menu


// WhatsApp do botão "Contato": só dígitos, com DDI e DDD (ex.: 5511999999999)
// shortcut: número ainda não definido; sem ele o botão do WhatsApp fica desativado. Configure REACT_APP_WHATSAPP_NUMBER.
export const WHATSAPP_NUMBER = (process.env.REACT_APP_WHATSAPP_NUMBER || "").replace(/\D/g, "");
export const WHATSAPP_MESSAGE = "Olá! Quero conhecer o Entertainment Maintenance para a minha loja.";

// Vídeos da landing ficam no bucket R2 site-videos-images (passam do limite de 25 MB por arquivo do Cloudflare Pages)
export const MEDIA_URL = process.env.REACT_APP_SITE_MEDIA_URL || "https://midia.emservice.com.br";
